module.exports = __webpack_public_path__ + "img/bottomImg3.4c83c9c5.png";